import * as ActionTypes from './types';

const initialState = {
  data: {},
  isFetching: false,
  lockedFilter: false,
};

export default function auditData(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.ADMIN_AUDIT_REPORT_REQUEST_DATA:
      return Object.assign({}, state, {
        isFetching: true,
      });

    case ActionTypes.ADMIN_AUDIT_REPORT_RECEIVE_DATA:
      return Object.assign({}, state, {
        isFetching: false,
        data: action.data,
      });

    default:
      return state;
  }
}
